import {Component, Input, OnInit} from "@angular/core";
import {ResponseData, SubmissionData} from "../../../shipper";
import {DatePipe, NgForOf, NgIf} from "@angular/common";
import {ISFSubmissionStatus} from "../isf.submission.status";


@Component({
    selector: "isf-transmission",
    standalone: true,
    templateUrl: "./isf.transmission.html",
    imports: [
        NgForOf,
        NgIf,
        DatePipe,
        ISFSubmissionStatus
    ],
    //styleUrls: ["isf.style.css"]
})
export class IsfTransmissionComponent implements OnInit{
    
    @Input()
    isf!:SubmissionData;

    isfResponse:Array<ResponseData> = [];

    constructor() {}

    ngOnInit(): void {
        
        /*
        this.isfData.subscribe((i) => {
            this.isfResponse = i.response.sort((r1,r2) => {
                if(r1.id > r2.id){return -1;}
                if(r1.id < r2.id){return 1;}
                return 0;
            });    
        })
        
         */
        
        
        this.isfResponse = this.isf.response.sort((r1,r2) => {
            if(r1.id > r2.id){return -1;}
            if(r1.id < r2.id){return 1;}
            return 0;
        });
    }
    
}
